import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TensorIcon() {
    return (_jsxs("svg", { className: "ui-size-full", viewBox: "0 0 26 22", fill: "currentColor", children: [_jsx("path", { d: "M14.8246 0V22L18.1088 18.8635V8.10998L21.1193 10.9776H26L14.8246 0Z" }), _jsx("path", { d: "M11.1754 0V22L7.89123 18.8635V8.10998L4.8807 10.9776H0L11.1754 0Z" })] }));
}
export default TensorIcon;
